import { createService, z } from '@bonanza-social/toolkit/api';
import { SearchResultsSchema, GameInfoSchema } from '../shared/games.schemas';
import { Game } from '../../state/shared/games.types';

export default {
  ...createService(
    {
      getGames: {
        method: 'GET',
        url: '/lobby/games',
        headers: {
          'x-api-version': '2',
        },
        responseSchema: z.any(), // passing a schema here causes performance issues. on prod we have 5K games
      },
      getSearchResults: {
        method: 'GET',
        headers: {
          'x-api-version': '2',
        },
        url: '/lobby/games/search',
        responseSchema: SearchResultsSchema,
      },
    },
    ({ userId }) => `/Players/${userId}`,
  ),
  ...createService({
    getPublicGames: {
      method: 'GET',
      url: '/lobby/games',
      headers: {
        'x-api-version': '2',
      },
      public: true,
      responseSchema: z.any(), // passing a schema here causes performance issues. on prod we have 5K games
    },
    getPublicSearchResults: {
      method: 'GET',
      headers: {
        'x-api-version': '2',
      },
      url: '/lobby/games/search',
      public: true,
      responseSchema: SearchResultsSchema,
    },
    getGameInfo: {
      method: 'GET',
      url: ({ gameId }: { gameId: Game['id'] }) => `/Games/${gameId}`,
      public: true,
      responseSchema: GameInfoSchema,
    },
  }),
};
